import { Helmet } from 'react-helmet';
import { Section, SectionItem } from '../components/Chrome';

const NotFoundPage = () => (
  <Section>
    <Helmet>
      <title>Page not found</title>
    </Helmet>
    <SectionItem>The page you requested doesn't exist.</SectionItem>
  </Section>
);

export default NotFoundPage;
